import { Store } from 'vuex'
import { State as StoreState } from '@/store/index'
import { useStoreAction } from '@/model/store/store'

/**
 * 初期化処理の実施
 * @param store vuex
 */
const init = (store: Store<StoreState>) => {
  // ヘッダー表示情報の初期化
  useStoreAction(store).headerInit()
}

export { init }
